<select #comboBox
  [(ngModel)]="selectedGroupingCode" [disabled]="disabled" [hidden]="!visible" [class.combo-box-required]="required"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]="tabindex" (change)="onChange($any($event.target).value);" (blur)="onTouched()">
  <ng-template ngFor let-item [ngForOf]="model.groupingList">
    <option value="{{item.GroupingCode}}">{{item.GroupingCodeName}}</option>
  </ng-template>
</select>
